import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";
import News from "@/pages/News";
import NewsPost from "@/pages/NewsPost";
import InterpreterLogin from "@/pages/InterpreterLogin";
import ClientLogin from "@/pages/ClientLogin";
import SetPassword from "@/pages/SetPassword";
import CustomerPortal from "@/pages/CustomerPortal";
import InterpreterPortal from "@/pages/InterpreterPortal";
import AdminDashboard from "@/pages/AdminDashboard";

function RoleRoute({ roles, children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function RoleRedirect() {
  const { user } = useAuth();
  if (user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "customer") return <Navigate to="/portal" replace />;
  if (user.role === "interpreter") return <Navigate to="/interpreter" replace />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  return <Navigate to="/" replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-right" richColors offset={72} />
        <BrowserRouter>
          <Routes>
            {/* Public marketing site */}
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:slug" element={<NewsPost />} />

            {/* Auth */}
            <Route path="/interpreter-login" element={<InterpreterLogin />} />
            <Route path="/login" element={<ClientLogin />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route path="/dashboard" element={<RoleRedirect />} />

            {/* Portals */}
            <Route
              path="/portal"
              element={
                <RoleRoute roles={["customer"]}>
                  <CustomerPortal />
                </RoleRoute>
              }
            />
            <Route
              path="/interpreter"
              element={
                <RoleRoute roles={["interpreter"]}>
                  <InterpreterPortal />
                </RoleRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <RoleRoute roles={["admin"]}>
                  <AdminDashboard />
                </RoleRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
